import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { switchMap, map, catchError, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as timesActions from '../actions/delivery-times.actions';
import { MwDeliveryTimesApiService } from 'app/services/delivery-times-api.service';
@Injectable()
export class DeliveryTimesEffects {
  constructor(
    private actions$: Actions,
    private deliveryTimesApiService: MwDeliveryTimesApiService
  ) {}

  loadDeliveryTimes$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(timesActions.loadDeliveryTimes),
      switchMap(({ loadOptions }) => {
        const options = loadOptions;
        return this.deliveryTimesApiService.get(options).pipe(
          map((response) => {
            return timesActions.loadDeliveryTimesSuccess({
              response,
            });
          }),
          catchError((error) =>
            of(timesActions.loadDeliveryTimesFailed({ error }))
          )
        );
      })
    );
  });

  createDeliveryTime$ = createEffect(() =>
    this.actions$.pipe(
      ofType(timesActions.createDeliveryTime),
      // not using switchMap here because multiple actions of this type can be dispatched at the same time
      mergeMap(({ time }) => {
        return this.deliveryTimesApiService.create(time).pipe(
          switchMap(() => [timesActions.createDeliveryTimeSuccess()]),
          catchError((error) =>
            of(timesActions.createDeliveryTimeFailed({ error }))
          )
        );
      })
    )
  );

  updateDeliveryTime$ = createEffect(() =>
    this.actions$.pipe(
      ofType(timesActions.updateDeliveryTime),
      // not using switchMap here because multiple actions of this type can be dispatched at the same time
      mergeMap(({ time }) => {
        return this.deliveryTimesApiService.update(time).pipe(
          switchMap(() => [timesActions.updateDeliveryTimeSuccess()]),
          catchError((error) =>
            of(timesActions.updateDeliveryTimeFailed({ error }))
          )
        );
      })
    )
  );

  deleteDeliveryTime$ = createEffect(() =>
    this.actions$.pipe(
      ofType(timesActions.deleteDeliveryTime),
      // not using switchMap here because multiple actions of this type can be dispatched at the same time
      mergeMap(({ time }) => {
        return this.deliveryTimesApiService.delete(time).pipe(
          switchMap(() => [timesActions.deleteDeliveryTimeSuccess()]),
          catchError((error) =>
            of(timesActions.deleteDeliveryTimeFailed({ error }))
          )
        );
      })
    )
  );

  deleteDeliveryTimesList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(timesActions.deleteDeliveryTimesList),
      switchMap(({ times }) => {
        return this.deliveryTimesApiService.deleteList(times).pipe(
          switchMap(() => [timesActions.deleteDeliveryTimesListSuccess()]),
          catchError((error) =>
            of(timesActions.deleteDeliveryTimesListFailed({ error }))
          )
        );
      })
    )
  );
}
